<template>
    <div class="popupHolder" @click.self="SendClose()">
        <div class="frame">
            <div class="inframe">
                <slot>
                
                </slot>
                <button type="button" class="btn btn-danger btn-close"><i class="glyphicon glyphicon-remove"  @click.self="SendClose()"></i></button>
                
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Popup',
  data () {
    return {
      isMoreDetails: false,
      setImage: '124'
    }
  },
  methods: {
    NewTabUrlOpen(val){
        alert(val)
        window.open(val, '_blank')
    },
    SendClose() {
        this.$emit('popclose')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-close {
  position: absolute;
  right: -15px;
  top: -15px;
  width: 30px;
  height: 30px;
  text-align: center;
  padding: 5px 0;
  font-size: 15px;
  line-height: 15px;
  border-radius: 15px;
}
.popupHolder {
    position: fixed;
    z-index: 499;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    padding: 0;
    background-color: rgba(0,0,0,0.7);    
}
.popupHolder .frame {
    display:inline-block;
    margin-top: 5vh;   
    margin-left: auto;
    margin-right: auto;
    height: auto;
    max-width: 600px; 
    min-height: 200px;
    min-width: 30%;
    width: auto;
  

}
.popupHolder .frame .inframe {
    position: relative;
    margin: 5px 10px;
    padding: 3px 7px 30px 7px;  
    display: block;
    height: auto;
    width: auto;
    background-color: rgba(255,255,255,0.9);
    box-shadow: 0 4px 2px -2px rgba(0,0,0,0.4);   
}
</style>



// WEBPACK FOOTER //
// src/components/Popup.vue